import { Pagination as MuiPagination, PaginationItem } from '@material-ui/lab';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';

const Pagination = ({ className, onChange, page, pageCount, totalCount, noMargin = false }) => {
    const {
        css,
        cx,
        theme: { spacing },
    } = useStyles();
    const count = Math.ceil(totalCount / pageCount);

    return count > 1 ? (
        <div
            className={css({ display: 'flex', justifyContent: 'center', marginTop: noMargin ? '0' : spacing(2.5), color: '#152652' })}
        >
            <MuiPagination
                count={count}
                onChange={(_, newPage) => onChange(newPage)}
                page={page}
            />
        </div>
    ) : null;
};

Pagination.propTypes = {
    pageCount: PropTypes.number,
    totalCount: PropTypes.number,
    onChange: PropTypes.func,
    page: PropTypes.number,
    className: PropTypes.string,
};

export default Pagination;
